$(function() {
    $('.pdw-search-close').on('click',function (e) {
        $('.pdw-search').removeClass('show');
    });
    $('.pdw-search-open').on('click',function (e) {
        $('.pdw-search').addClass('show');
    });
    $('.pdw-search-toggler').on('click',function (e) {
        $('.pdw-search').toggleClass('show');
    });
});